module.exports = __webpack_public_path__ + "img/confirmed-round-icon.41a3ac2b.svg";